package com.shadowings.gero.data.repository

import com.shadowings.gero.domain.model.Chapter
import com.shadowings.gero.domain.repository.ChapterRepository
import com.shadowings.gero.data.datasource.JsonChapterDataSource

class ChapterRepositoryImpl(
    private val dataSource: JsonChapterDataSource
) : ChapterRepository {
    override suspend fun getChapters(): List<Chapter> = dataSource.getChapters()
}

